import React, { memo } from 'react';
import {
  Box,
  Button,
  Dialog,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { COMPLETED, DARCKBACKGROUND, DARCKCOLOR, DARCKOPACITYCOLOR6, ONGOING, UPCOMING } from '../../helpers/Config';
import { Link } from 'react-router-dom';
import closeImage from '../../assets/closeImage.svg';
import { format } from 'date-fns';
import { formatTime } from '../../helpers/Utils';

const StatusCard = ({ status, dateTime, handleCanselBooking, handleConnectBooking }) => {
  const customizer = useSelector((state) => state.customizer);
  const [open, setOpen] = React.useState(false);

  const handleCancel = (e) => { 
    e.stopPropagation();
    setOpen(true)
  };

  const handleCancelGuide = (e) => {
    e.stopPropagation();
    setOpen(false);
    handleCanselBooking();
  };
  
  const handleContact = (e) => {
    e.stopPropagation();
    handleConnectBooking();
  };

  return (
    <Box width={'100%'} px={'4px'} onClick={(e) => e.stopPropagation()}>
      <Dialog maxWidth="100vw" open={open} onClose={() => setOpen(false)} sx={{ "& .MuiPaper-root": { margin: "0 !important", borderRadius: "25px", } }}>
        <Box px={2} pt={2} pb={3} sx={{ width: "calc(100vw - 30px)", maxWidth: "350px" }}>
          <Box mb={3}>
            <Stack direction="row" justifyContent="space-between" alignItems={"center"}>
              <Typography variant="h6" sx={{ fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: DARCKCOLOR }}>
                Canceling the guide
              </Typography>
              <IconButton
                color="inherit"
                aria-label="arrow"
                onClick={(e) => setOpen(false) && e.stopPropagation()}
                sx={{
                  transform: 'translateX(8px)',
                }}
              >
                <Box
                  component="img"
                  src={closeImage}
                  alt="img"
                  sx={{
                    width: '24px',
                    height: '24px',
                  }}
                />
              </IconButton>
            </Stack>
            <Typography variant="body2" sx={{ fontSize: "12px", fontWeight: 300, lineHeight: "20px", transform: 'translateY(-8px)', color: "rgba(33, 37, 41, 0.7)" }}>
              Do you really want to cancel the guide?
            </Typography>
          </Box>
          <Stack
            mt={2}
            direction="row"
            justifyContent="space-between"
            spacing={2}
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={(e) => setOpen(false) && e.stopPropagation()}
              sx={{
                height: '48px',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px',
                backgroundColor: '#fff',
                color: 'rgba(2, 122, 255, 1)',
                borderRadius: '16px',
                border: '1px solid rgba(33, 37, 41, 0.2)',
                '&:hover': {
                  backgroundColor: 'rgba(33, 37, 41, 1)',
                  color: '#fff',
                },
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={(e) => handleCancelGuide(e)}
              sx={{
                height: '48px',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px',
                backgroundColor: '#fff',
                color: 'rgba(2, 122, 255, 1)',
                borderRadius: '16px',
                border: '1px solid rgba(33, 37, 41, 0.2)',
                '&:hover': {
                  backgroundColor: 'rgba(33, 37, 41, 1)',
                  color: '#fff',
                },
              }}
            >
              Confirm 
            </Button>
          </Stack>
        </Box>
      </Dialog>
      <Box width={'100%'} p={1} bgcolor={DARCKBACKGROUND} borderRadius={'16px'}>
        {(status === UPCOMING || status === ONGOING) ? (
          <Stack
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            gap={1}
            pr={2}
            onClick={(e) => handleContact(e)}
          >
            <Stack
              direction={'column'}
              justifyContent={'space-between'}
              alignItems={'flex-start'}
              gap={'5px'}
            >
              <Typography
                variant="body2"
                fontSize={'14px'}
                fontWeight={400}
                lineHeight={'20px'}
                color={'#fff'}
              >
                Click to connect (for test)
              </Typography>
              <Box
                p={'4px 10px'}
                borderRadius={'21px'}
                bgcolor={'#fff'}
              >
                <Typography
                  variant="body2"
                  fontSize={'12px'}
                  fontWeight={400}
                  lineHeight={'16px'}
                  color={DARCKCOLOR}
                  textTransform={'capitalize'}
                >
                  {status}
                </Typography>
              </Box>
              <Typography
                variant="body2"
                fontSize={'14px'}
                fontWeight={400}
                lineHeight={'20px'}
                color={'#fff'}
              >
                {dateTime?.length ? format(new Date(dateTime), 'dd MMMM yyyy') : '07 December 2024'}
              </Typography>
            </Stack>
            <Typography
              variant="body2"
              fontSize={'14px'}
              fontWeight={400}
              lineHeight={'20px'}
              color={'#fff'}
            >
              {dateTime?.length ? formatTime(dateTime) : '8:00 AM'}
            </Typography>
          </Stack>
        ) : (
          <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={1}>
            <Box
              p={'4px 10px'}
              borderRadius={'21px'}
              bgcolor={'#fff'}
            >
              <Typography
                variant="body2"
                fontSize={'12px'}
                fontWeight={400}
                lineHeight={'16px'}
                color={DARCKCOLOR}
                textTransform={'capitalize'}
              >
                {status}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              fontSize={'14px'}
              fontWeight={400}
              lineHeight={'20px'}
              color={'#fff'}
            >
              {dateTime?.length ? format(new Date(dateTime), 'dd MMMM yyyy') : '07 December 2024'}
            </Typography>
          </Stack>
        )}
      </Box>
      {(status === UPCOMING || status === ONGOING) && (
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={1} pt={'4px'}>
          <Box
            onClick={(e) => {
              e.stopPropagation();
              window.open('https://wa.me/+34652344783', '_blank');
            }}
            sx={{
              width: '49%',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '20px',
              color: DARCKOPACITYCOLOR6,
              backgroundColor: '#fff',
              padding: '14px',
              textAlign: 'center',
              '&:hover': {
                backgroundColor: DARCKBACKGROUND,
                color: '#fff',
              },
            }}
          >
            Contact
          </Box>
          <Button
            onClick={(e) => handleCancel(e)}
            sx={{
              width: '49%',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '20px',
              color: DARCKOPACITYCOLOR6,
              backgroundColor: '#fff',
              padding: '14px',
              textAlign: 'center',
              '&:hover': {
                backgroundColor: DARCKBACKGROUND,
                color: '#fff',
              },
            }}
          >
            Cancel
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default memo(StatusCard);
